import { useEffect, useRef } from "react"
import styled from "styled-components"
import mixins from "../../../styles/mixins";

const Wrap = styled.div`
    position: relative;
    height: fit-content;
    width: fit-content;

    svg {
        overflow: hidden;
        path {
            width: 100%;
            height: 100%;
            stroke-width: 16;
            stroke-linecap: round;
            stroke-miterlimit: 10;
            stroke-dashoffset: 30;

            &.frame {
                stroke: rgba(225, 242, 237, 1);
            }
            &.bar {
                stroke: rgba(28, 195, 145, 1);
            }
        }
    }

    .value {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        font-weight: 400;
        line-height: calc(19.2 / 12);
        text-align: center;

        .caption {
            ${mixins.caption};
            white-space: nowrap;
            color: rgba(132, 132, 132, 1);
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, -77%);
        }

        > span {
            font-size: 16px;
            font-weight: 600;
            line-height: calc(22.4 / 16);
        }
    }
`

export default function HalfCircleProgress({value=0, name="", ...props}) {
    const wrapRef = useRef();
    const barRef = useRef();

    
    function progress(per) {
        const RADIUS = 54;
        const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
        const progress = per / 100;
        const dashoffset = CIRCUMFERENCE * (1 - progress) * -1;

        return {
            dashoffset: dashoffset,
            strokeDasharray: CIRCUMFERENCE,
        };
    }

    useEffect(() => {
        const attr = progress(value);
        
        barRef.current.style.strokeDasharray = attr.strokeDasharray;
        barRef.current.style.strokeDashoffset = attr.dashoffset;
    },[value]);

    return (
        <Wrap ref={wrapRef} data-progress={value}>
            <svg x="0px" y="0px" width="95" height="55" viewBox="-5 0 210 103">
                <path className="frame" fill="none" d="M195.675,98.851 c0-52.17-42.822-94.463-95.644-94.463c-52.823,0-95.644,42.293-95.644,94.463" />
                <path ref={barRef} className="bar" fill="none" d="M195.675,98.851 c0-52.17-42.822-94.463-95.644-94.463c-52.823,0-95.644,42.293-95.644,94.463" />
            </svg>
            <strong className="value">
                <p className="caption">{name}</p>
                <span>{value}</span>점
            </strong>
        </Wrap>
    )
}